<template>
  <AppHome>
    <div slot="main">
      <!--
      <section class="section">
        <List v-if="isSelectedRewardAvailable">
          <ListItemWithIcon slot="list-item" icon-position="left" text-align="left">
            <img slot="list-item-icon" src="~assets/images/icons/ic-gift/ic-gift.png">
            <div slot="list-item-text">
              <h6 class="list-item__header" :style="globalStylePrimaryColorText">
                Cadeau débloqué !
              </h6>
              <div class="list-item__paragraph">
                Récupérez le produit lors de vos prochaines courses.
              </div>
            </div>
          </ListItemWithIcon>
          <RewardHome
            slot="list-item"
            :reward="selectedReward"
            @click.native.stop.prevent="openCatalogModal(selectedReward)"
          />
        </List>

        <List v-else-if="isSelectedRewardSoonAvailable">
          <ListItemWithIcon
            slot="list-item"
            icon-position="left"
            clickable
            @click.native.stop.prevent="$router.push('/profile/shoot')"
          >
            <img slot="list-item-icon" src="~assets/images/icons/ic-receipt/ic-receipt.png">
            <div slot="list-item-text">
              <div class="list-item__paragraph">
                Photographiez votre prochain ticket de caisse avec
                <strong>FidMarques</strong>
                pour cumuler des points !
              </div>
              <div class="list-item__paragraph">
                <strong :style="globalStylePrimaryColorText">
                  1€ d'achat = 2 points
                </strong>
              </div>
            </div>
          </ListItemWithIcon>
          <ListItemWithIcon slot="list-item" icon-position="left">
            <img slot="list-item-icon" src="~assets/images/icons/ic-gift/ic-gift.png">
            <div slot="list-item-text">
              <h6 class="list-item__header" :style="globalStylePrimaryColorText">
                Plus que {{ selectedReward.missing_points }}
                {{ selectedReward.missing_points >= 2 ? 'points' : 'point' }} !
              </h6>
              <div class="list-item__paragraph">
                Vous pouvez le modifier à tout moment dans le catalogue.
              </div>
            </div>
          </ListItemWithIcon>
          <RewardHome
            slot="list-item"
            :reward="selectedReward"
            @click.native.stop.prevent="openCatalogModal(selectedReward)"
          />
        </List>
      </section>
      -->

      <section>
        <List>
          <TheHomeDisclaimerAndros
            v-if="isAndros"
            slot="list-item"
            :emphasis-style="globalStylePrimaryColorText"
          />

          <ListItemWithIcon
            slot="list-item"
            icon-position="left"
          >
            <img slot="list-item-icon" src="~assets/images/icons/ic-receipt/ic-receipt.png">
            <div slot="list-item-text">
              <h6 class="list-item__header" :style="globalStylePrimaryColorText">
                1€ d'achat = 2 points
              </h6>
              <div class="list-item__paragraph">
                Déclarer mes achats pour cumuler des points !<br>
                selon le format de mon ticket :
              </div>
            </div>
          </ListItemWithIcon>

          <TheShootInstructions slot="list-item" />

          <ListItemWithIcon
            slot="list-item"
            icon-position="left"
            clickable
            @click.native.stop.prevent="$router.push('/profile/shop')"
          >
            <img slot="list-item-icon" src="~assets/images/icons/ic-gift/ic-gift.png">
            <div slot="list-item-text">
              <h6 class="list-item__header" :style="globalStylePrimaryColorText">
                Votre catalogue cadeau
              </h6>
              <div class="list-item__paragraph">
                Échanger mes points contre des remboursements.
              </div>
            </div>
          </ListItemWithIcon>

          <RewardHome
            v-if="selectedReward || lowestReward"
            slot="list-item"
            :reward="selectedReward || lowestReward"
            @click.native.stop.prevent="openCatalogModal(selectedReward || lowestReward)"
          />

          <!--
          <ListItemWithIcon slot="list-item" icon-position="left">
            <img slot="list-item-icon" src="~assets/images/icons/ic-gift/ic-gift.png">
            <div slot="list-item-text">
              <h6 class="list-item__header" :style="globalStylePrimaryColorText">
                Votre prochain cadeau
              </h6>
              <div class="list-item__paragraph">
                Vous pouvez le modifier à tout moment dans le catalogue.
              </div>
            </div>
          </ListItemWithIcon>
          <-- Lowest Reward appears selected ->
          <RewardHome
            slot="list-item"
            :reward="selectedReward || lowestReward"
            @click.native.stop.prevent="openCatalogModal(selectedReward || lowestReward)"
          />
          -->
        </List>
      </section>

      <Timeline />
    </div>

    <!--
    <AppFooter
      slot="footer"
      button-text="Changer de cadeau"
      button-text-bold
      button-path="/catalog"
    />
    -->
    <!-- <FabShoot slot="footer" /> -->

    <RewardModal
      v-if="isModalOpened"
      slot="modal"
      selection-disabled
      @close="closeCatalogModal"
    />
  </AppHome>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import AppHome   from '~/components/layout/Home'
// import AppFooter from '~/components/layout/Footer'
import List             from '~/components/elements/List'
import ListItemWithIcon from '~/components/elements/ListItemWithIcon'
import RewardHome  from '~/components/elements/RewardHome'
import RewardModal from '~/components/modals/Reward'

import Timeline from '~/components/features/timeline/Index'
// import FabShoot from '~/components/shared/FabShoot'
import TheHomeDisclaimerAndros from '~/components/shared/TheHomeDisclaimerAndros'
import TheShootInstructions from '~/components/shared/TheShootInstructions'

import MixinPrimaryColor from '~/mixins/primaryColor'
import MixinWhiteLabel from '~/mixins/isWhiteLabel'

export default {
  middleware: 'authenticated',

  components: {
    AppHome,
    // AppFooter,
    List,
    ListItemWithIcon,
    RewardHome,
    RewardModal,
    Timeline,
    // FabShoot,
    TheHomeDisclaimerAndros,
    TheShootInstructions,
  },
  mixins: [
    MixinPrimaryColor,
    MixinWhiteLabel,
  ],
  computed: {
    ...mapGetters('card', [
      // 'isSelectedRewardAvailable',
      // 'isSelectedRewardSoonAvailable',
      'selectedReward',
      'lowestReward',
    ]),
    ...mapState('layout', {
      isModalOpened: 'catalogIsModalOpened',
      modalReward:   'catalogModalReward',
    }),
    ...mapGetters('server', ['isAndros']),
  },
  methods: {
    ...mapActions('layout', ['closeCatalogModal', 'openCatalogModal']),
  },
}
</script>

<style scoped>
.list-item__header {
  margin-bottom: 1rem;
}
</style>
